import {
  Box,
  FormControl,
  FormControlProps,
  FormHelperText,
  InputLabel,
  InputLabelProps,
  PaperProps,
} from "@mui/material";
import { ReactNode } from "react";

import { TypeHelper } from "@/common/helpers/type";

interface Props {
  label: ReactNode;
  /** Arbitrary input to wrap. */
  input: ReactNode;
  padding?: "none" | "dense" | "normal";
  error?: boolean;
  helperText?: ReactNode;
  formControlProps?: FormControlProps;
  labelControlProps?: InputLabelProps;
  sx?: PaperProps["sx"];
}

/** Mimics MUI's OutlinedInput styles, allowing to wrap arbitrary input component to get similar look as OutlinedInput. */
export function OutlinedInputWrapper({
  label,
  input,
  padding,
  error,
  helperText,
  formControlProps,
  labelControlProps,
  sx,
}: Props) {
  return (
    <FormControl sx={sx} variant='outlined' error={error} {...formControlProps}>
      <InputLabel shrink focused={false} size='small' error={error} {...labelControlProps}>
        {label}
      </InputLabel>

      <Box
        sx={{
          position: "relative",
          paddingY: padding === "dense" ? "8.5px" : padding === "normal" ? "16.5px" : undefined,
          paddingX: padding === "dense" ? "14px" : padding === "normal" ? "14px" : undefined,
          borderRadius: (th) => th.shapeCustom.borderRadiusInput,
        }}
      >
        <Box sx={{}}>{input}</Box>

        {/* Mimic MuiOutlinedInput-notchedOutline */}
        <Box
          component='fieldset'
          sx={{
            pt: 0,
            textAlign: "left",
            position: "absolute",
            bottom: 0,
            right: 0,
            top: -5,
            left: 0,
            margin: 0,
            padding: "0 8px",
            pointerEvents: "none",
            borderRadius: "inherit",
            borderStyle: "solid",
            borderWidth: 1,
            overflow: "hidden",
            minWidth: "0%",
            borderColor: (th) => th.palette.divider,
          }}
          aria-hidden='true'
        >
          <Box
            component='legend'
            sx={{
              px: 0.5,
              float: "unset",
              width: "auto",
              overflow: "hidden",
              display: "block",
              padding: 0,
              height: 11,
              fontSize: "0.75em",
              visibility: "hidden",
              whiteSpace: "nowrap",
              maxWidth: "100%",
              transition: "max-width 100ms cubic-bezier(0.0, 0, 0.2, 1) 50ms",
            }}
          >
            <Box
              component='span'
              sx={{
                paddingLeft: "5px",
                paddingRight: "5px",
                display: "inline-block",
                opacity: 0,
                visibility: "visible",
              }}
            >
              Fuel level
            </Box>
          </Box>
        </Box>
      </Box>

      {helperText ? (
        TypeHelper.isString(helperText) ? (
          <FormHelperText error={error}>{helperText}</FormHelperText>
        ) : (
          helperText
        )
      ) : null}
    </FormControl>
  );
}
